import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {Text} from '@vio/atlas/Text'
import {Brand} from '@vio/core/src/brand/types'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'
import {FooterSocialButton} from '@vio/shared/src/whiteLabel/CustomFooter'

interface Props {
  brand: Brand
  isSingleColumn: boolean
}
export const FooterSocialSection = ({brand, isSingleColumn}: Props) => {
  return (
    <div>
      <Text variant="titleL" tag="p">
        <FormattedMessageWrapper id="social" defaultMessage="Social" />
      </Text>
      <Box paddingTop="s400">
        <Box
          display="flex"
          gap="s300"
          justifyContent={isSingleColumn ? 'center' : 'flex-start'}
        >
          <FooterSocialButton
            url={brand.socials?.instagramUrl}
            iconName="Instagram"
          />
          <FooterSocialButton
            url={brand.socials?.facebookUrl}
            iconName="Facebook"
          />
          <FooterSocialButton
            url={brand.socials?.linkedinUrl}
            iconName="Linkedin"
          />
        </Box>
      </Box>
    </div>
  )
}
